/* Presentation only. The existing Hot Box cart owns order and subscription rules. */
(() => {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-hbp-br]').forEach(root => {
      if (root.dataset.hbpReady) return;
      root.dataset.hbpReady = 'true';
      const form = root.querySelector('form[action*="/cart/add"]');
      const quantity = form?.querySelector('[name="quantity"]');
      const mainButton = root.querySelector('[data-hbp-add]');
      const sticky = root.querySelector('[data-hbp-sticky]');
      const stickyButton = root.querySelector('[data-hbp-sticky-add]');
      const drawer = document.getElementById('HBBoxCart');
      const smallScreen = window.matchMedia('(max-width: 989px)');
      let mainButtonVisible = true;
      function syncSticky() {
        sticky.hidden = !smallScreen.matches || mainButtonVisible || (drawer && !drawer.hidden);
        stickyButton.disabled = mainButton.disabled;
      }
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          mainButtonVisible = entries[0].isIntersecting;
          syncSticky();
        });
        observer.observe(mainButton);
        const stateObserver = new MutationObserver(syncSticky);
        stateObserver.observe(mainButton, {attributes:true,attributeFilter:['disabled']});
        if (drawer) stateObserver.observe(drawer, {attributes:true,attributeFilter:['hidden']});
        smallScreen.addEventListener('change', syncSticky);
      }
      // Both buttons submit the same native product form, captured once by HBBoxCart.
      root.querySelectorAll('[data-hbp-photo]').forEach(button => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-hbp-photo-id]').forEach(photo => photo.classList.toggle('is-active', photo.dataset.hbpPhotoId === button.dataset.hbpPhoto));
          root.querySelectorAll('[data-hbp-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      root.querySelectorAll('[data-hbp-quantity-change]').forEach(button => {
        button.addEventListener('click', () => {
          if (!quantity) return;
          if (button.dataset.hbpQuantityChange === '1') quantity.stepUp(); else quantity.stepDown();
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
        });
      });
      const variants = JSON.parse(root.querySelector('[data-hbp-variants]').textContent);
      let subscriptionConfig = null;
      function updateSubscriptionNote() {
        const variant = variants.find(item => String(item.id) === String(form?.elements.namedItem('id')?.value));
        const eligible = subscriptionConfig?.enabled === true && variant?.available && subscriptionConfig.plans?.some(plan => !plan.prepaid && plan.interval === 'MONTH' && plan.intervalCount === 1 && variant.planIds.some(id => String(id) === String(plan.sellingPlanId)));
        root.querySelector('[data-hbp-subscription]').hidden = !eligible;
      }
      root.querySelector('[data-hbp-variant]')?.addEventListener('change', event => {
        const variant = variants.find(item => String(item.id) === event.target.value);
        if (!variant) return;
        root.querySelectorAll('[data-hbp-price]').forEach(price => { price.textContent = variant.price; });
        mainButton.disabled = !variant.available;
        root.querySelectorAll('[data-hbp-add-label]').forEach(label => { label.textContent = variant.available ? 'Add to cart' : 'Sold out'; });
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = variant.min;
        updateSubscriptionNote();
        syncSticky();
      });
      if (variants.some(variant => variant.planIds.length)) {
        const base = (root.dataset.root || '/').replace(/\/?$/, '/');
        fetch(base + 'apps/manage-subscriptions?r=config', {credentials:'same-origin'})
          .then(response => response.ok ? response.json() : null)
          .then(config => { subscriptionConfig = config; updateSubscriptionNote(); }).catch(() => {});
      }
      // Move the existing review section, preserving its nodes and accessibility order.
      const main = document.getElementById('MainContent');
      const productSection = root.closest('.shopify-section');
      const reviews = main?.querySelector('.hbp-product-reviews--widget')?.closest('.shopify-section');
      if (productSection?.parentElement === main && reviews?.parentElement === main && reviews !== productSection) {
        productSection.after(reviews);
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
